import React, { useRef } from "react";
import logo_KK_white_200 from "../img/logo_KK_white_200.png";
import logo_KK_color_200 from "../img/logo_KK_color_200.png";
import logo_ZK_white from "../img/logo_ZK_white.png";
import logo_ZK_color from "../img/logo_ZK_color2.png";
import logo_DOP_HC_white from "../img/logo_DOP-HC_white.png";
import logo_DOP_HC_color from "../img/logo_DOP-HC_color.png";
import projekt from "../img/projekt.jpg";
import projekt_250 from "../img/projekt_250.jpg";
import projekt2 from "../img/projekt2.jpg";
import projekt2_250 from "../img/projekt2_250.jpg";
import facebook from "../img/facebook.png";
import { Link } from "react-router";
import {
  HiOutlineHome,
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineLocationMarker,
  HiOutlineAtSymbol,
  HiOutlineUsers,
  HiOutlineLibrary,
} from "react-icons/hi";
import Map from "./map";

const Footer = () => {
  const Hr = () => {
    return (
      <div className="border-b-[1px] border-gray-400 my-4 w-full md:w-3/4"></div>
    );
  };

  const Contact = ({ icon, text, name }) => {
    return (
      <div className="flex items-center space-x-2">
        <span>{icon}</span>
        <p>{text}</p>
        <p className="font-semibold">{name}</p>
      </div>
    );
  };

  const ImageToggleOnMouseOver = ({ primaryImg, secondaryImg, alt }) => {
    const imageRef = useRef(null);
    const imgClasses = "w-[100px] md:w-full";

    return (
      <img
        onMouseOver={() => {
          imageRef.current.src = secondaryImg;
        }}
        onMouseOut={() => {
          imageRef.current.src = primaryImg;
        }}
        className={imgClasses}
        src={primaryImg}
        alt={alt}
        ref={imageRef}
      />
    );
  };

  const onButtonClick = (url, name) => {
    const pdfUrl = url;
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = name; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const carProjectItems = [
    {
      id: 1,
      name: "Registrační číslo:",
      text: "CZ.06.6.127/0.0/0.0/21_124/0016805",
    },
    { id: 2, name: "Realizace projektu:", text: "01.06.2021 - 01.07.2022" },
    { id: 3, name: "Celkové výdaje projektu:", text: "996 662 Kč" },
    { id: 4, name: "Příspěvek EU:", text: "847 162,70 Kč" },
    { id: 5, name: "Spolufinancování:", text: "49 833,10 Kč" },
  ];

  const carProject2Items = [
    {
      id: 1,
      name: "Registrační číslo:",
      text: "CZ.06.05.01/00/22_049/0006753",
    },
  ];

  const openHours = [
    { id: 1, day: "Po:", time: "7:00 - 15:30" },
    { id: 2, day: "Út:", time: "7:00 - 15:30" },
    { id: 3, day: "St:", time: "7:00 - 15:30" },
    { id: 4, day: "Čt:", time: "7:00 - 15:30" },
    { id: 5, day: "Pá:", time: "7:00 - 15:30" },
  ];

  const documents = [
    {
      id: 1,
      url: "./documents/aktualni_jidelnicek.pdf",
      name: "aktualni_jidelnicek.pdf",
      text: "Aktualní jídelní lístek",
    },
    { id: 2, url: "./documents/gdpr.pdf", name: "gdpr.pdf", text: "GDPR" },
    {
      id: 3,
      url: "./documents/letak_2026.pdf",
      name: "letak_2026.pdf",
      text: "Informační leták 2026",
    },
    {
      id: 4,
      url: "./documents/sazebnik_ukonu_2026.pdf",
      name: "sazebnik_ukonu_2026.pdf",
      text: "Sazebník úkonů platný od 1.7.2026",
    },
  ];

  const annualReports = [
    {
      id: 1,
      url: "./documents/vz/vz_2023.pdf",
      name: "vz_2023.pdf",
      text: "VZ 2023",
    },
    {
      id: 2,
      url: "./documents/vz/vz_2022.pdf",
      name: "vz_2022.pdf",
      text: "VZ 2022",
    },
    {
      id: 3,
      url: "./documents/vz/vz_2021.pdf",
      name: "vz_2021.pdf",
      text: "VZ 2021",
    },
    {
      id: 4,
      url: "./documents/vz/vz_2020.pdf",
      name: "vz_2020.pdf",
      text: "VZ 2020",
    },
    {
      id: 5,
      url: "./documents/vz/vz_2019.pdf",
      name: "vz_2019.pdf",
      text: "VZ 2019",
    },
    {
      id: 6,
      url: "./documents/vz/vz_2018.pdf",
      name: "vz_2018.pdf",
      text: "VZ 2018",
    },
    {
      id: 7,
      url: "./documents/vz/vz_2017.pdf",
      name: "vz_2017.pdf",
      text: "VZ 2017",
    },
  ];

  return (
    <footer
      id="footer"
      className="min-h-[150px] bg-cyan-800 px-3 text-white flex flex-col items-center"
    >
      <div className="flex flex-col md:container pt-5 px-2 md:px-0">
        <div className="flex flex-col md:flex-row w-full items-center justify-evenly space-y-5 mb-2">
          <Link
            to="https://www.kr-karlovarsky.cz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageToggleOnMouseOver
              primaryImg={logo_KK_white_200}
              secondaryImg={logo_KK_color_200}
              alt="Logo Karlovarský kraj"
            />
          </Link>
          <Link
            to="https://www.zivykraj.cz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageToggleOnMouseOver
              primaryImg={logo_ZK_white}
              secondaryImg={logo_ZK_color}
              alt="Logo Živý kraj"
            />
          </Link>
        </div>
        <p className="text-center">
          Činnost organizace je realizována za finanční podpory MPSV ČR a
          Karlovarského kraje
        </p>
      </div>

      <Hr />

      <div className="flex flex-col md:container items-center my-5 px-2 md:px-0">
        <h3 className="font-bold text-lg text-center mb-3">
          Projekt Pořízení automobilů pro Centrum sociálních služeb Sokolov,
          o.p.s.
        </h3>
        <p className="mb-2 text-center">
          Projektem byly pořízeny dva automobily pro účely poskytování terénní
          sociální služby - Pečovatelská služba a byl spolufinancován z Evropské
          unie
        </p>
        <div className="flex flex-col md:flex-row items-center justify-evenly w-full">
          <div className="mb-2">
            <ul>
              {carProjectItems.map((oneItem) => {
                const { id, name, text } = oneItem;

                return (
                  <li key={id}>
                    <span className="inline-block w-[200px]">{name}</span>
                    <strong className="">{text}</strong>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="mb-2">
            <img
              src={projekt_250}
              alt="Projekt Pořízení automobilů pro Centrum sociálních služeb Sokolov, o.p.s."
              onClick={() => window.open(projekt, "_blank")}
              className="rounded cursor-pointer grayscale	hover:grayscale-0"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col md:container items-center my-5 px-2 md:px-0">
        <h3 className="font-bold text-lg text-center mb-3">
          Projekt Pořízení nízkoemisního automobilu pro Centrum sociálních
          služeb Sokolov, o.p.s.
        </h3>
        <p className="mb-2 text-center">
          V rámci projektu č. CZ.06.05.01/00/22_049/0006753 bylo Centrem
          sociálních služeb Sokolov, o.p.s. pořízeno nízkoemisní vozidlo pro
          účely poskytování terénní sociální služby – pečovatelská služba. Tento
          nákup vozidla byl finančně podpořen Evropskou unií.
        </p>
        <div className="flex flex-col md:flex-row items-center justify-evenly w-full">
          <div className="mb-2">
            <ul>
              {carProject2Items.map((oneItem) => {
                const { id, name, text } = oneItem;

                return (
                  <li key={id}>
                    <span className="inline-block w-[200px]">{name}</span>
                    <strong className="">{text}</strong>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="mb-2">
            <img
              src={projekt2_250}
              alt="Projekt Pořízení automobilů pro Centrum sociálních služeb Sokolov, o.p.s."
              onClick={() => window.open(projekt2, "_blank")}
              className="rounded cursor-pointer grayscale	hover:grayscale-0"
            />
          </div>
        </div>
      </div>

      <Hr />

      <div className="mb-2">
        <p className="mb-2">Spolupracujeme:</p>
        <div className="flex justify-center ">
          <Link
            to="https://www.dop-hc.cz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageToggleOnMouseOver
              primaryImg={logo_DOP_HC_white}
              secondaryImg={logo_DOP_HC_color}
              alt="Logo Dům ošetřovatelské péče - home care"
              title="Dům ošetřovatelské péče - home care"
            />
          </Link>
        </div>
      </div>

      <Hr />

      <div className="flex flex-col md:flex-row md:container items-center md:items-start justify-evenly space-y-5 md:space-y-0 px-2 md:px-0">
        <div className="">
          <div className="mb-2">
            <h3 className="font-bold text-lg">Dokumenty</h3>
            <ul>
              {documents.map((oneDocument) => (
                <li key={oneDocument.id}>
                  <button
                    onClick={() =>
                      onButtonClick(`${oneDocument.url}`, `${oneDocument.name}`)
                    }
                    className="underline hover:no-underline hover:text-amber-400"
                  >
                    {oneDocument.text}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="">
            <h3 className="font-bold text-lg">Výroční zprávy</h3>
            <ul>
              {annualReports.map((oneReport) => (
                <li key={oneReport.id}>
                  <button
                    onClick={() =>
                      onButtonClick(`${oneReport.url}`, `${oneReport.name}`)
                    }
                    className="hover:underline"
                  >
                    {oneReport.text}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h3 className="font-bold text-lg">Provozní doba</h3>
          <ul>
            {openHours.map((oneDay) => (
              <li key={oneDay.id}>
                <strong className="inline-block w-[30px]">{oneDay.day}</strong>
                {oneDay.time}
              </li>
            ))}
          </ul>
          <p className="w-[250px]">
            Mimo tuto dobu, včetně <strong>víkendů</strong> a{" "}
            <strong>svátků</strong>, po předchozí dohodě:{" "}
          </p>
          <p>6:00 - 7:00 a 15:30 - 22:00</p>
        </div>

        <div id="contacts">
          <h3 className="font-bold text-lg text-center">Kontakty</h3>
          <div>
            <Contact
              icon={<HiOutlineHome />}
              text={
                <strong className="text-xl">
                  Centrum sociálních služeb Sokolov, o.p.s.
                </strong>
              }
            />
            <Contact
              icon={<HiOutlineLocationMarker />}
              text="J. z Poděbrad 2046, 356 01 Sokolov"
            />
            <Contact icon={<HiOutlinePhone />} text="359 808 408" />
            <Contact icon="IČ:" text="28015819" />
            <Contact icon={<HiOutlineAtSymbol />} text="DS: yyhv8pz" />
            <Contact
              icon={<HiOutlineLibrary />}
              text="b.ú. u KB a.s.: 43-2522100227/0100"
            />
            <div className="flex items-center space-x-2">
              <span>
                <img src={facebook} alt="Facebook logo" className="h-5" />
              </span>
              <p>
                <a
                  href="https://www.facebook.com/profile.php?id=61583412839163"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  Facebook profil CSSS
                </a>
              </p>
            </div>
            <div className="mt-3">
              <p>
                ředitelka (statut.zástupce):
                <strong className="ms-2 lg:text-[18px]">
                  Bc. Magdalena Osičková
                </strong>
              </p>
              <Contact
                icon={<HiOutlinePhone className="ms-2" />}
                text="721 940 521"
              />
              <Contact
                icon={<HiOutlineMail className="ms-2" />}
                text={
                  <a
                    href="mailto:reditelka@css-sokolov.cz"
                    className="underline"
                  >
                    reditelka@css-sokolov.cz
                  </a>
                }
              />
              <Contact
                icon={<HiOutlineMail className="ms-2" />}
                text={
                  <a href="mailto:m.osickova@volny.cz" className="underline">
                    m.osickova@volny.cz
                  </a>
                }
              />
            </div>
            <div className="mt-3">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlineUsers />}
                        text="správní rada: "
                      />
                    </td>
                    <td className="ps-2">
                      Mgr. Petr Born (předseda), Mgr. Magdaléna Hadravová,
                      Jaroslav Eliáš
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlineUsers />}
                        text="dozorčí rada: "
                      />
                    </td>
                    <td className="ps-2">
                      Bc. Vlasta Kaiserová (předsedkyně), Mgr. Bc. Jiří Blecha,
                      LL.M, Libuše Móczárová
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-3">
              <p>
                účetní:
                <strong className="ms-2 lg:text-[18px]">
                  Libuše Móczárová
                </strong>
              </p>
              <Contact
                icon={<HiOutlinePhone className="ms-2" />}
                text="602 724 709"
              />
              <Contact
                icon={<HiOutlineMail className="ms-2" />}
                text={
                  <a href="mailto:ucetni@css-sokolov.cz" className="underline">
                    ucetni@css-sokolov.cz
                  </a>
                }
              />
              <Contact
                icon={<HiOutlineMail className="ms-2" />}
                text={
                  <a href="mailto:ucetni.csss@volny.cz" className="underline">
                    ucetni.csss@volny.cz
                  </a>
                }
              />
            </div>
          </div>
          <div>
            <div className="mt-3">
              <p className="font-semibold">
                Domy s nízkonákladovými byty pro seniory a terén
              </p>

              <table>
                <tbody>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlinePhone className="ms-2" />}
                        text="vedoucí služby: "
                      />
                    </td>
                    <td className="ps-2">607 080 537</td>
                  </tr>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlinePhone className="ms-2" />}
                        text="sociální pracovnice: "
                        name="Bc. Diana Švadlenková, DiS."
                      />
                    </td>
                    <td className="ps-2">702 207 944</td>
                  </tr>

                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlinePhone className="ms-2" />}
                        text="vedoucí pečovatelka: "
                      />
                    </td>
                    <td className="ps-2">721 360 801</td>
                  </tr>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlinePhone className="ms-2" />}
                        text="pečovatelky ul. J. z Poděbrad: "
                      />
                    </td>
                    <td className="ps-2">723 038 210</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className="ps-2">725 418 867</td>
                  </tr>
                  <tr>
                    <td>
                      <Contact
                        icon={<HiOutlinePhone className="ms-2" />}
                        text="pečovatelky ul. Komenského: "
                      />
                    </td>
                    <td className="ps-2">602 724 798</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className="ps-2">702 098 188</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Hr />

      <div className="md:container">
        <p className="font-bold text-lg text-center mb-3">Kde nás najdete</p>
        <Map />
      </div>

      <Hr />

      <div className="md:container text-center px-2 md:px-0">
        <h3 className="font-bold text-lg mb-3">
          GDPR - Informace o zpracování osobních údajů
        </h3>
        <p className="mb-2">
          Organizace zpracovává osobní a citlivé údaje v souladu s Nařízením EP
          a Rady (EU) 2016/679 ze dne 27. dubna 2016 o ochraně fyzických osob v
          souvislosti se zpracováním osobních údajů a o volném pohybu těchto
          údajů a o zrušení směrnice 95/46/ES a dále v souladu s relevantními
          vnitrostátními právními předpisy v oblasti ochrany osobních
          údajů.Organizace shromažďuje a zpracovává osobní údaje pouze v souladu
          se stanovenými účely a v rozsahu a po dobu nezbytnou pro naplnění
          těchto stanovených účelů.
        </p>
        <p>
          Více informací o zpracování osobních údajů naleznete v{" "}
          <button
            onClick={() => onButtonClick("./documents/gdpr.pdf", "gdpr.pdf")}
            className="hover:underline uppercase"
          >
            tomto
          </button>{" "}
          dokumentu.
        </p>
      </div>

      <Hr />

      <div className="flex flex-col justify-center items-center">
        <div className="">Počet návštěvníků stránek</div>
        <div className="" id="sfcy9ttr4gqfh1c3d1c6r97z97perruyt43">
          <script
            type="text/javascript"
            src="https://counter6.optistats.ovh/private/counter.js?c=y9ttr4gqfh1c3d1c6r97z97perruyt43&down=async"
            async
          ></script>
          <noscript>
            <a href="https://www.freecounterstat.com" title="free stat counter">
              <img
                src="https://counter6.optistats.ovh/private/freecounterstat.php?c=y9ttr4gqfh1c3d1c6r97z97perruyt43"
                border="0"
                title="free stat counter"
                alt="free stat counter"
              />
            </a>
          </noscript>
        </div>
      </div>

      <Hr />

      <div className="text-center">
        &copy;{" "}
        <a href="mailto:petr.kovacik@gmail.com" className="underline">
          Petr Kováčik
        </a>{" "}
        2025 - 2026
      </div>
    </footer>
  );
};

export default Footer;
